import { useRef, useState, useEffect } from "react";

/**
 * Shared hook for GRN detail/return detail screens to manage
 * PDF dialog state and the collapsible tracking sidebar.
 */
export const useGrnDetailLayout = () => {
  const rightSidebarRef = useRef<HTMLDivElement>(null);
  const [rightSidebarOpen, setRightSidebarOpen] = useState<boolean>(false);
  const [docType, setDocType] = useState<string>("");
  const [openPdf, setOpenPdf] = useState<boolean>(false);

  const toggleRightSidebar = () => {
    setRightSidebarOpen((prev) => !prev);
  };

  const handleOpenPdf = (type: string) => {
    setDocType(type);
    setOpenPdf(true);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target as Node) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rightSidebarOpen]);

  return {
    rightSidebarRef,
    rightSidebarOpen,
    setRightSidebarOpen,
    toggleRightSidebar,
    docType,
    openPdf,
    setOpenPdf,
    handleOpenPdf,
  };
};
